export interface User {
  _id: string
  email: string
  name: string
  superAdmin: boolean
}

export interface UserWithOrgs extends User {
  organizations: Array<{
    _id: string
    name: string
    active: boolean
    role: MembershipRoles
  }>
}

export enum MembershipRoles {
  Admin = "admin",
  Member = "member",
}
